<template>
  <div>
    <home></home>
  </div>
</template>

<script>
import home from "@/components/Home";
export default {
  components: {
    home
  }
};
</script>

<style>
</style>